import Logo from "../../../src/assets/logo.png";
import AuthButton from "../../components/ui-components/auth-items/AuthButton";
import {
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AuthWrapper from "../../components/ui-components/auth-items/authWrapper";
import AuthCardWrapper from "../../components/ui-components/auth-items/authCardWrapper";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { performSSOLogin } from "../../Redux/LoginAction";
import "./Auth.css";

const Auth = () => {
  const theme = useTheme();
  const matchDownSM = useMediaQuery(theme.breakpoints.down("md"));
  const [searchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    if (token != null) {
      setIsLoading(true);

      const fetchUser = async () => {
        await performSSOLogin(token, navigate);
        setIsLoading(false);
      };

      fetchUser();
    }
  }, [searchParams, navigate]);

  return (
    <>
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <AuthWrapper>
          <Grid
            container
            direction="column"
            justifyContent="flex-end"
            className="auth-container"
          >
            <Grid item xs={12}>
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                className="auth-wrapper"
              >
                <Grid item className="auth-card">
                  <AuthCardWrapper className="auth-card-wrapper">
                    <Grid
                      className="auth-card-content"
                      container
                      direction="column"
                      spacing={2}
                      alignItems="center"
                      justifyContent="flex-start"
                    >
                      <Grid item className="login-logo login-logo-large">
                        <img alt="Logo" src={Logo} />
                      </Grid>
                      <Grid item xs={12}>
                        <Grid
                          container
                          direction={matchDownSM ? "column-reverse" : "row"}
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Grid item>
                            <Stack
                              alignItems="center"
                              justifyContent="center"
                              spacing={1}
                            >
                              <Typography variant="h2" className="signin-title">
                                Sign-in
                              </Typography>
                              <Typography
                                variant="caption"
                                className="signin-caption"
                              >
                                to continue update Subaru Dealer Data.
                              </Typography>
                            </Stack>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} className="auth-button-row mt-5 pt-5">
                        <div className="auth-button-animate">
                          <AuthButton />
                        </div>
                      </Grid>
                    </Grid>
                  </AuthCardWrapper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </AuthWrapper>
      )}
    </>
  );
};

export default Auth;